import { UseValidation } from '../../helpers/useValidation';
import { CERTIFICATES } from '../certificate/certificates';
import { CertificateFromLacuna } from '../certificate/lacunaService';
import { Exam } from '../../interfaces/exam';

/**
 * CERTIFICADOS
 * Deixei esse código separado para reduzir um pouco o código que está dentro do PrescriptionProvider
 */
export interface CertificatesContext {
  selectedCertificateType: CERTIFICATES | null;
  setSelectedCertificateType(value: CERTIFICATES): void;
  localCertificateValidation: UseValidation;

  selectedLocalCertificate: CertificateFromLacuna | null;
  setSelectedLocalCertificate(certificate: CertificateFromLacuna): void;

  digitalCertificateIsRequired: boolean;
}

/**
 * Verifica se todos os exames da prescrição têm CID específico preenchido.
 * Quando verdadeiro, o CID geral não é obrigatório mesmo que a flag esteja habilitada.
 *
 * @param {Exam[]} exams - Lista de exames da prescrição
 * @returns {boolean} Verdadeiro se todos os exames têm CID específico
 */
export function allExamsHaveSpecificIcd(exams: Exam[]): boolean {
  return exams.length > 0 && exams.every((exam) => exam.CID10Estruturado && exam.CID10Estruturado.length > 0);
}

export const CertificateContextDefaultValues: CertificatesContext = {
  selectedCertificateType: null,
  setSelectedCertificateType: () => {},

  localCertificateValidation: {
    errorMessage: '',
    hasError: false,
    validate: () => true,
  },
  selectedLocalCertificate: null,
  setSelectedLocalCertificate: () => {},

  digitalCertificateIsRequired: false,
};
